import {
  SUPERVISELIST,
} from 'actions/supervise';
import {reducerPackage} from "../../utils";

export const superviseList = reducerPackage(SUPERVISELIST);
